/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@eternal/Components/Headings/SectionTitle';
import MidContainer from '@eternal/Components/Layout/MidContainer';
import StructuredTextParser from '@eternal/Components/Utility/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/* Services */

/**
 *
 * @param {Object} param0
 * @returns
 */
const AboutEE = ({ sectionContent, region, lang }) => {
  const findElement = param =>
    sectionContent.find(el => el._modelApiKey === param);
  return (
    <Box width="100%" bg="#040404" h="auto">
      <MidContainer w={630} py={{ base: '20px', md: '40px' }}>
        <SectionTitle titleObj={findElement('section_title')} />
        <StructuredTextParser
          color="#fff"
          fontFamily="FedraSansStd-book"
          fontSize={{ base: '16px', md: '18px' }}
          lineHeight={{ base: '24px', md: '34px' }}
          str={render(findElement('structured_text').body)}
          sx={{
            p: {
              marginBottom: { base: '15px', md: '20px' },
              display: 'block',
            },
          }}
        />
      </MidContainer>
    </Box>
  );
};

export default AboutEE;
